import React, { useEffect } from 'react';
import { useAuth as useOidcAuth } from 'react-oidc-context';

/**
 * Componente para manejar el callback de OIDC después de la autenticación
 * Este componente se renderiza cuando el usuario regresa de Cognito
 */
const OidcCallback: React.FC = () => {
  const oidcAuth = useOidcAuth();

  useEffect(() => {
    // react-oidc-context maneja automáticamente el callback
    // Solo necesitamos redirigir cuando la autenticación esté completa
    if (!oidcAuth.isLoading) {
      if (oidcAuth.isAuthenticated) {
        console.log('✅ Autenticación exitosa, redirigiendo al dashboard');
        window.location.replace('/dashboard');
      } else if (oidcAuth.error) {
        // Si hay un error, redirigir a kubiy.com
        console.error('❌ OIDC authentication error:', oidcAuth.error);
        console.error('Detalles del error:', JSON.stringify(oidcAuth.error, null, 2));
        window.location.replace('https://kubiy.com');
      }
    }
  }, [oidcAuth.isLoading, oidcAuth.isAuthenticated, oidcAuth.error, oidcAuth.user]);

  // Mostrar loading mientras se procesa el callback
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-white mb-4"></div>
        <p className="text-gray-600 dark:text-gray-400">Completing authentication...</p>
      </div>
    </div>
  );
};

export default OidcCallback;

